const screenerSessionResults = {
  QUALIFIED: 'qualified',
  DISQUALIFIED: 'disqualified',
};

export default screenerSessionResults;
